import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import HeroMain from "../../components/innerPageHero/HeroMain";
import Pagereview from "../../components/pageReview/Pagereview";
import cardImg from "../../assets/images/card-image.jpg";
import SegmentedTab from "../../components/segmentedTab/SegmentedTab";
import {
  getPromotionAwareness,
  getPromotionAwarenessCategory,
} from "../../utils/apiCalls";
import { FormContext } from "../CMSRenderer/CMSRenderer";

const AwarenessCard = ({ title, fileAr, fileName, image, view, currentLang }) => (
  <a href={`/${currentLang === "en" ? fileName : fileAr}`} target="_blank">
    <dda-image-card
      image_src={view === "grid" ? (image ? `/${image}` : cardImg) : ""}
      custom_class="cursos-pointer"
      component_mode=""
      class="hydrated"
    >
      <div className="-mt-4">
        <div className="flex justify-between mt-5">
          <p className="body Bold text-primary">{title}</p>
          {currentLang === "en" ? (
            <i class="material-symbols-outlined text-primary">
              arrow_circle_right
            </i>
 
          ) : (
            <i class="material-symbols-outlined text-primary">
              arrow_circle_left
            </i>
          )}
        </div>
      </div>
    </dda-image-card>
  </a>
);

const HealthPromotionAndAwareness = ({ config }) => {
  const [view, setView] = useState("grid");
  const [showAll, setShowAll] = useState(false);
  const { currentLang } = useContext(FormContext);
  const [search, setSearch] = useState("");
  const [promotionData, setPromotionData] = useState({
    category: [],
    promotion: [],
  });
  const [isLoading, setIsLoading] = useState(false);

  const [activeTab, setActiveTab] = useState(0);
  const tabsRef = useRef(null);
  const searchInputRef = useRef(null);

  useEffect(() => {
    const handleInputChanged = (e) => {
      const value = e.target?.value || e.detail?.value || "";
      setSearch(value);
    };

    const handleOnChanged = (e) => {
      const value = e.target?.value || e.detail?.value || "";
      setSearch(value);
    };

    const searchElement = searchInputRef.current;
    if (searchElement) {
      searchElement.addEventListener('inputChanged', handleInputChanged);
      searchElement.addEventListener('onChanged', handleOnChanged);
      
      return () => {
        searchElement.removeEventListener('inputChanged', handleInputChanged);
        searchElement.removeEventListener('onChanged', handleOnChanged);
      };
    }
  }, []);

  const handleSearchInput = (e) => {
    const value = e.target?.value || "";
    setSearch(value);
  };

  useEffect(() => {
    const currentTabs = tabsRef.current;
    if (currentTabs) {
      const handler = (event) => {
        setActiveTab(event.detail);
      };
      currentTabs.addEventListener("tabClick", handler);
      return () => currentTabs.removeEventListener("tabClick", handler);
    }
  }, []);

  useEffect(() => {
    setIsLoading(true);
    getPromotionAwarenessCategory({ page: 1, pageSize: 10 }).then((res) => {
      if (!res?.data) return setIsLoading(false);
      
      const sortedCategories = (res.data || []).sort((a, b) => 
        new Date(a.createdAt) - new Date(b.createdAt)
      );
      
      setPromotionData((prev) => ({
        ...prev,
        category: sortedCategories,
      }));
      setIsLoading(false);
    });
  }, []);

  useEffect(() => {
    const category = promotionData.category[activeTab];
    if (!category?.dguid) return;
    setIsLoading(true);
    getPromotionAwareness({
      page: 1,
      pageSize: 10,
      cateID: category.dguid,
    }).then((res1) => {
      console.log("res1", res1);
      if (res1?.data) {
        const tempData = res1.data.map((item) => ({
          title:
            currentLang === "en"
              ? item.titleEn
              : item.titleAr
              ? item.titleAr
              : item.titleEn,
          href: item.file,
          fileName: item.fileName,
          fileAr: item.fileAr,
          image: item.image,
          createdAt: item.createdAt,
        }));

        setPromotionData((prev) => ({
          ...prev,
          promotion: tempData,
        }));
      }
      setIsLoading(false);
    });
  }, [activeTab, promotionData.category]);

  const filteredPromotions = useMemo(() => {
    let filtered = promotionData.promotion;
    
    if (search && search.trim() !== "") {
      const searchLower = search.toLowerCase().trim();
      filtered = filtered.filter(item => {
        const title = item?.title || "";
        return title.toLowerCase().includes(searchLower);
      });
    }
    
    return filtered;
  }, [search, promotionData.promotion]);

  const displayData = useMemo(() => {
    return showAll ? filteredPromotions : filteredPromotions.slice(0, 10);
  }, [showAll, filteredPromotions]);

  console.log("check");

  return (
    <>
      <h2 className="mb-4 Medium text-primary">
        {currentLang === "en"
          ? config.header
          : config.header_ar
          ? config.header_ar
          : config.header}
      </h2>
      <h5
        className="my-2 text-onSurfaceVariant Regular body"
        dangerouslySetInnerHTML={{
          __html:
            currentLang === "en"
              ? config.body
              : config.body_ar
              ? config.body_ar
              : config.body,
        }}
      />

      <div className="flex flex-wrap items-center gap-3 w-full my-4">
        <div className="sm:flex-1">
          <dda-search-input
            ref={searchInputRef}
            placeholder={
              currentLang === "en"
                ? config.search_input_placeholder
                : config.search_input_placeholder_ar
                ? config.search_input_placeholder_ar
                : config.search_input_placeholder
            }
            size="default"
            custom_class="w-full"
            onInput={handleSearchInput}
            show_button="false"
            helper_text=""
            error_message=""
            validation_id=""
            has_error="false"
            component_mode=""
            button_id="button"
            input_id="Search"
            aria_label="search-input"
            button_aria_label="clear-search"
            search_input_name="search-input"
            close_button_name="close-button"
            search_button_name="search-button"
          ></dda-search-input>
        </div>
        <div>
          <SegmentedTab onChange={setView} />
        </div>
      </div>
      <dda-tabs
        ref={tabsRef}
        type="text"
        hover_style="dda-tab-underline-filled"
        tab_texts={JSON.stringify(
          promotionData?.category?.map((i) =>
            currentLang === "en"
              ? i?.titleEn
              : i?.titleAr
              ? i?.titleAr
              : i?.titleEn
          )
        )}
      ></dda-tabs>

      {/* Cards */}
      <div className={`flex ${view === "list" ? "flex-col gap-4 my-4" : "grid xl:grid-cols-5 md:grid-cols-2 gap-4 my-4"}`}>
        {isLoading ? (
          <div className="col-span-full text-center py-8">
            <p className="text-gray-500">
              {currentLang === "en" 
                ? "Loading..." 
                : "تحميل ..."
              }
            </p>
          </div>
        ) : displayData.length > 0 ? (
          displayData.map((item, idx) => (
            <AwarenessCard 
              key={idx} 
              title={item?.title} 
              fileName={item?.fileName} 
              fileAr={item?.fileAr} 
              image={item?.image} 
              view={view} 
              currentLang={currentLang}
            />
          ))
        ) : search && search.trim() !== "" ? (
          <div className="col-span-full text-center py-8">
            <p className="text-gray-500">
              {currentLang === "en" 
                ? "No data found" 
                : "لا توجد بيانات"
              }
            </p>
          </div>
        ) : (
          <div className="col-span-full text-center py-8">
            <p className="text-gray-500">
              {currentLang === "en" 
                ? "No data found" 
                : "لا توجد بيانات"
              }
            </p>
          </div>
        )}
      </div>

      {filteredPromotions.length > 10 && !search && (
        <div className="flex justify-center mt-6">
          <dda-button
            button_color="default-primary"
            start_icon=""
            button_text={
              showAll
                ? currentLang === "en"
                  ? config?.show_less
                  : config.show_less_ar
                : currentLang === "en"
                ? config.show_all
                : config.show_all_ar
            }
            end_icon=""
            custom_class="px-8"
            component_mode=""
            button_id="toggle-show-button"
            aria_label="toggle show cards"
            button_name="toggle-show-button"
            onclick={() => setShowAll(!showAll)}
          ></dda-button>
        </div>
      )}

      
    </>
  );
};

export default HealthPromotionAndAwareness;
